import { z } from 'zod';

export const timeSlotSchema = z.object({
  startTime: z.string(),
  endTime: z.string(),
});

export const weeklyAvailabilitySchema = z.object({
  monday: z.array(timeSlotSchema).optional(),
  tuesday: z.array(timeSlotSchema).optional(),
  wednesday: z.array(timeSlotSchema).optional(),
  thursday: z.array(timeSlotSchema).optional(),
  friday: z.array(timeSlotSchema).optional(),
  saturday: z.array(timeSlotSchema).optional(),
  sunday: z.array(timeSlotSchema).optional(),
});

export const placeTranslationSchema = z.object({
  languageCode: z.string(),
  title: z.string({ message: 'Dodajte naslov' }),
  description: z.string({ message: 'Dodajte opis' }),
  shortDescription: z.string().optional(),
  audioIds: z.array(z.string()).optional(),
  videoIds: z.array(z.string()).optional(),
});

export const placeCreateSchema = z.object({
  name: z.string({ message: 'Dodajte naziv' }),
  translations: z.array(placeTranslationSchema),
  imageIds: z.array(z.string()).optional(),
  mapId: z.string({ message: 'Dodajte mapu sobe' }),
  weeklyAvailability: weeklyAvailabilitySchema.optional(),
});
